/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithGoogle } from '../../actions/auth';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const GoogleCallback = ({ loginWithGoogle }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleGoogleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
    
      if (!code) {
        console.error('Authorization code is missing');
        navigate('/login'); // Redirect to login if no code is found
        return;
      }

      try {
        await loginWithGoogle(code);
        navigate("/welcome", { replace: true })
      } catch (error) {
        console.error('Error during Google login:', error.response?.data || error.message);
        navigate('/login');
      }
    };

    handleGoogleCallback();
  }, [navigate, loginWithGoogle]);

  return <div>Processing Google Login...</div>;
};

GoogleCallback.propTypes = {
    loginWithGoogle: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, { loginWithGoogle })(GoogleCallback);
